import { render, staticRenderFns } from "./CamstudyPromptModal.vue?vue&type=template&id=cab2ab8a&scoped=true&"
import script from "./CamstudyPromptModal.vue?vue&type=script&lang=js&"
export * from "./CamstudyPromptModal.vue?vue&type=script&lang=js&"
import style0 from "./CamstudyPromptModal.vue?vue&type=style&index=0&id=cab2ab8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab2ab8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cab2ab8a')) {
      api.createRecord('cab2ab8a', component.options)
    } else {
      api.reload('cab2ab8a', component.options)
    }
    module.hot.accept("./CamstudyPromptModal.vue?vue&type=template&id=cab2ab8a&scoped=true&", function () {
      api.rerender('cab2ab8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/camstudyPromptModal/CamstudyPromptModal.vue"
export default component.exports